<template>
  <div class="bread__crumd__block">
    <div class="el-breadcrumb">
      <span
        v-for="(item, index) in $route.meta.breadCrumb"
        :key="index"
        class="el-breadcrumb__item"
      >
        <span class="el-breadcrumb__inner is-link" @click="handleClick(item.path)">
          {{ item.name }}
        </span>
        <i class="el-breadcrumb__separator el-icon-arrow-right"></i>
      </span>
    </div>
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in $route.meta.breadCrumb"
        :key="index"
        :to="{ path: item.path }"
      >
        {{ item.name }}
      </el-breadcrumb-item>
    </el-breadcrumb> -->
  </div>
</template>
<script>
export default {
  created() {
    // console.log("this.$route.meta.breadCrumb",this.$route.meta.breadCrumb);
  },
  methods: {
    handleClick(path) {
      if (!path || path === '') return
      this.$router.push({
        path: path,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  .bread__crumd__block {
    flex: 1 1 0;
    min-width: 0;
    overflow: hidden;
    padding-left: 10px;
    padding-right: 12px;

    .el-breadcrumb {
      display: flex;
      align-items: center;
      white-space: nowrap;
      min-width: 0;
    }

    .el-breadcrumb__item {
      display: flex;
      align-items: center;
      flex: 0 0 auto;
      float: none;

      &:last-child {
        flex: 1 1 auto;
        min-width: 0;
        width: auto !important;

        .el-breadcrumb__inner {
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  @media (max-width: 1000px) {
    .bread__crumd__block {
      display: none;
    }
  }
</style>
